/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Vast_Dove_SwimInputs */

const en_tame_vast_dove_swim = /** @type {(inputs: Tame_Vast_Dove_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit selected`)
};

const de_tame_vast_dove_swim = /** @type {(inputs: Tame_Vast_Dove_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit selected" |
*
* @param {Tame_Vast_Dove_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_vast_dove_swim = /** @type {((inputs?: Tame_Vast_Dove_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Vast_Dove_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_vast_dove_swim(inputs)
	return de_tame_vast_dove_swim(inputs)
});